import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import ReviewForm from './ReviewForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import style from './styles/style.module.css';


class EditReviewModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            deleteConfirm: false,
            fetching: false,
        };
    }
    submitHandler = ( values ) => {
        this.setState( { fetching: true } );
        this.props.updateReview( values.id, { ...values } )
        .then( ( review ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( review );
        } );
    }
    toggleDeleteConfirmation = ( state ) => {
        return () => {
            this.setState( { deleteConfirm: state } );
        };
    }
    deleteReview = () => {
        this.setState( { fetching: true } );
        this.props.deleteReview( this.props.review.id )
        .then( () => {
            this.setState( { fetching: false, deleteConfirm: false } );
            this.props.onSubmit && this.props.onSubmit( null );
        } );
    }



    render() {
        const { review } = this.props;
        return (
            <DLModal title='Edit Review'
            closeHandler={ this.props.closeModal }>
                <div>
                    <ReviewForm next={ this.submitHandler } initialValues={ review } />
                    { this.renderDeleteSection() }
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }

    renderDeleteSection = () => {
        if( this.state.deleteConfirm ) {
            return (
                <div className={style.deleteLink}>
                    <p>ARE YOU SURE YOU WANT TO DELETE THIS REVIEW?</p>
                    <p>
                        <span className={ style.confirmDelete }
                        onClick={ this.deleteReview }>
                            DELETE REVIEW
                        </span>
                        <span className={ style.cancelDelete }
                        onClick={ this.toggleDeleteConfirmation( false ) }>
                            CANCEL
                        </span>
                    </p>
                </div>
            );
        }
        return (
            <div className={style.deleteLink}>
                <span
                onClick={ this.toggleDeleteConfirmation( true ) }>
                    DELETE THIS REVIEW
                </span>
            </div>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        updateReview: ( reviewid, data ) => {
            return dAPI.patch( `/admin/reviews/${ reviewid }`, data );

        },
        deleteReview: ( reviewid ) => {
            return dAPI.delete( `/admin/reviews/${ reviewid }` );

        },
    };
};

export default connect( null, mapDispatchToProps )( EditReviewModal );
